import React from "react";
import { connect } from "react-redux";

import { decodeHandler, epocToDate } from "utils";
import { firstLetterUpper } from "../../../../../../utils";
import { deepClone } from "./../../../../../../utils";
import Tooltip from "App/common/ui/Tooltip";

function AddDevices(props) {
  function onSelectDevice(device, isAll) {
    let tempPlan = { ...props.planSettings };
    if (
      isAll &&
      Object.keys(props.clients).length === props.planSettings.devices.length
    ) {
      tempPlan.devices = [];
    } else {
      if (
        tempPlan.devices.filter(e => e.clientUUID === device.clientUUID)
          .length > 0
      ) {
        if (!isAll) {
          const index = tempPlan.devices.findIndex(
            e => e.clientUUID === device.clientUUID
          );
          tempPlan.devices.splice(index, 1);
        }
      } else {
        tempPlan.devices.push({
          clientName: device.name,
          clientUUID: device.clientUUID
        });
      }
    }
    tempPlan = checkNonEnabledDevicesQuota(deepClone(tempPlan));
    props.setPlanSettings(tempPlan);
  }

  function checkNonEnabledDevicesQuota(tempPlan) {
    let newDevices = [];
    tempPlan.devices.forEach(dev => {
      if (!JSON.stringify(props.cacheSettings).includes(dev.clientUUID)) {
        newDevices.push(dev.clientUUID);
      }
    });
    let notConfiguredDevices = 0;
    newDevices.forEach(dev => {
      if (!props.clients[dev].isConfigured) {
        notConfiguredDevices++;
      }
    });
    if (notConfiguredDevices === 0) {
      tempPlan.maxClientsExceeded = false;
    } else if (
      props.computerLimit <
        notConfiguredDevices +
          Object.keys(props.clients).filter(
            val => props.clients[val].isConfigured
          ).length &&
      props.planType !== "Paid" &&
      props.ecommerceFlag !== "S"
    ) {
      tempPlan.maxClientsExceeded = true;
    } else {
      tempPlan.maxClientsExceeded = false;
    }
    return tempPlan;
  }

  function selectAllDevices() {
    Object.keys(props.clients).map((client, i) => {
      onSelectDevice(props.clients[client], true);
    });
  }

  return (
    <div className="plan_cont_blk">
      <div className="tabular_data_wrap">
        <div
          className={`table_inner_header ${
            props.planSettings.devices.length > 0 &&
            Object.keys(props.clients).length !==
              props.planSettings.devices.length
              ? "semiactive"
              : ""
          }`}
        >
          <ul className="table_container">
            <li className="table_header">
              <div className="col">
                <div className="check_wrap">
                  <div className="check big">
                    {props.planSettings.devices.length > 0 && (
                      <input
                        onClick={selectAllDevices}
                        type="checkbox"
                        className="input_checkbox"
                        id="checkall_udevice"
                        checked
                      />
                    )}
                    {props.planSettings.devices.length === 0 && (
                      <input
                        onClick={selectAllDevices}
                        type="checkbox"
                        className="input_checkbox"
                        id="checkall_udevice"
                      />
                    )}
                    <label htmlFor="checkall_udevice"></label>
                  </div>
                </div>
              </div>
              <div className="col col1">
                <div className="">
                  {/* <span className="icon_sort file_sort_empty"></span> */}
                  <span className="header_title">Name</span>
                </div>
              </div>
              <div className="col col2">
                <div className="">
                  {/* <span className="icon_sort file_sort_empty"></span> */}
                  <span className="header_title">Backup Status </span>
                </div>
              </div>
              <div className="col col3">
                <div className="">
                  {/* <span className="icon_sort file_sort_empty"></span> */}
                  <span className="header_title">Last Backup Date</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="table_content_body ">
          <ul className="table_container">
            {Object.keys(props.clients).map((client, i) => {
              return (
                <li
                  className={[
                    "table_data_row list_folder",
                    props.planSettings.devices.filter(
                      val => val.clientUUID === props.clients[client].clientUUID
                    ).length > 0
                      ? "active"
                      : ""
                  ].join(" ")}
                  key={i}
                >
                  <div
                    className="inner_data_row"
                    onClick={() => onSelectDevice(props.clients[client], false)}
                  >
                    <div className="col">
                      <div className="check_wrap">
                        {props.planSettings.devices.length > 0 &&
                          props.planSettings.devices.filter(
                            val =>
                              val.clientUUID ===
                              props.clients[client].clientUUID
                          ).length > 0 && (
                            <div className="check big">
                              <input
                                type="checkbox"
                                className="input_checkbox"
                                id={"udevice_" + i}
                                checked
                              />
                              <label htmlFor={"udevice_" + i}></label>
                            </div>
                          )}
                        {(props.planSettings.devices.length === 0 ||
                          props.planSettings.devices.filter(
                            val =>
                              val.clientUUID ===
                              props.clients[client].clientUUID
                          ).length === 0) && (
                          <div className="check big">
                            <input
                              type="checkbox"
                              className="input_checkbox"
                              id={"udevice_" + i}
                            />
                            <label htmlFor={"udevice_" + i}></label>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col col1">
                      <div
                        className={[
                          "pc_name_blk",
                          props.clients[client].machineStatus
                        ].join(" ")}
                      >
                        <i className="pc-icon"></i>

                        {/* checking if lenght of machine name is more than 30,
                          than only showing tooltip and doing substring operation */}
                        {decodeHandler(props.clients[client].name).length >
                        30 ? (
                          <Tooltip
                            title={decodeHandler(props.clients[client].name)}
                            placement="top"
                          >
                            <span className="">
                              {/* {props.clients[client].name} */}

                              {decodeHandler(props.clients[client].name)
                                .toString()
                                .substring(
                                  0,
                                  decodeHandler(props.clients[client].name)
                                    .length - 25
                                ) + "..."}
                            </span>
                          </Tooltip>
                        ) : (
                          <span className="">
                            {decodeHandler(props.clients[client].name)}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col col2">
                      <span
                        className={[
                          "bkp_status ",
                          props.enums.BackupScheduleStatus.props[
                            props.clients[client].status.value
                          ].key === "IN_PROGRESS"
                            ? "progress"
                            : props.enums.BackupScheduleStatus.props[
                                props.clients[client].status.value
                              ].key === "PAUSED"
                            ? "paused"
                            : props.clients[client].lastBackupTime === 0
                            ? "new"
                            : props.enums.BackupScheduleStatus.props[
                                props.clients[client].status.value
                              ].key.toLowerCase()
                        ].join(" ")}
                      >
                        {props.enums.BackupScheduleStatus.props[
                          props.clients[client].status.value
                        ].key === "IN_PROGRESS"
                          ? "In Progress"
                          : props.clients[client].lastBackupTime === 0
                          ? "New"
                          : firstLetterUpper(
                              props.enums.BackupScheduleStatus.props[
                                props.clients[client].status.value
                              ].key
                            )}
                      </span>
                    </div>
                    <div className="col col3">
                      {props.clients[client].lastBackupTime === 0
                        ? "Never"
                        : epocToDate(
                            props.clients[client].lastBackupTime,
                            "MMM d yyyy, hh:mm:ss"
                          )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    clients: state.dashboard.clients.list,
    enums: state.common.enums,
    computerLimit: state.account.plan && state.account.plan.computerLimit,
    ecommerceFlag: state.account.ecommerceFlag,
    planType: state.account.plan && state.account.plan.planType,
    cacheSettings: state.backupPlan.cachePlanSettings
  };
}

export default connect(mapStateToProps)(AddDevices);
